import React from 'react';
import Help from './HelpApp';

const HelpEntry = () => {
  return <Help />;
};

export default HelpEntry;
